export default [
  {
    id: '15636176FEB',
    accept: true,
    de: "Standard: Allgemein/Halb-/Privat (SSO/Dentotar)",
    en: "Default: General/Semi/Private (SSO/Dentotar)"
  },
  {
    id: '15FE3B22767',
    accept: true,
    de: "Sonstige: IV, Unfall, Sozialleistung",
    en: "Other: IV, accident, EL, social benefits"
  }
]
